import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Personalizationcomponent } from './components/Personalization/Personolization.component';
import { PersonalizeCardComponent } from './components/personalize-card/personalize-card.component';
import { ImageCropperControlComponent } from './components/image-cropper-control/image-cropper-control.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { HasUnsavedDataGuard } from 'src/app/hasunsaveddata.guard';
import { SharedModule } from 'src/app/shared/shared.module';
import { VideoCardSharedModule } from '../video-card-shared/video-card-shared.module';
import { PersonaliseRouting } from './personalise-routing.module';
import { PremiumInvitesComponent } from './components/premium-invites/premium-invites.component';
import { EditVideoForMeComponent } from './components/edit-video-for-me/edit-video-for-me.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InsTextComponent } from './components/ins-text/ins-text.component';
import { HowItWorksEditComponent } from './components/how-it-works-edit/how-it-works-edit.component';

@NgModule({
  declarations: [HowItWorksEditComponent, Personalizationcomponent, PersonalizeCardComponent, ImageCropperControlComponent, PremiumInvitesComponent, EditVideoForMeComponent, InsTextComponent,],
  imports: [
    CommonModule,
    ImageCropperModule,
    CarouselModule,
    SharedModule,
    VideoCardSharedModule,
    PersonaliseRouting,
    DragDropModule
  ],
  entryComponents: [ImageCropperControlComponent, PremiumInvitesComponent],
  providers: [HasUnsavedDataGuard]
})
export class PersonaliseModule { }
